import {
    getCountryDropdown,
    getBranchValues,
    getUserDetails,
    setResultMessage,
    getUserDetailsExternal
} from './actions'

const dispatchGetCountryDropdown = (dispatch:Function) => () => {
    dispatch(getCountryDropdown());
  };
  const dispatchBrahchValues = (dispatch:Function) => () => {
    dispatch(getBranchValues());
  };
  const dispatchGetUserDetail = (dispatch:Function) => (user:any) => {
    dispatch(getUserDetails(user));
  };
  const getResultMessage = (dispatch:Function) => (value:any) => {
    dispatch(setResultMessage(value));
  };

  const dispatchGetUserDetailsExternal=(dispatch:Function)=>(email:string)=> dispatch(getUserDetailsExternal(email));

const operations = {
    dispatchGetCountryDropdown,
    dispatchBrahchValues,
    dispatchGetUserDetail,
    getResultMessage,
    dispatchGetUserDetailsExternal,
}

export default operations